export function addOrRemoveRepairType(arr: number[], item: number): number[] {
  const index = arr.findIndex((existingItem) => existingItem === item);
  return index !== -1 ? arr.filter((_, i) => i !== index) : [...arr, item];
}
